export default __webpack_public_path__ + "static/media/people10full.5e7ac3fe.jpg";